import gql from 'graphql-tag';

export default gql`
mutation competencyDocumentDelete(
    $documentId: UUID!,
    $workspaceId: UUID!
  ) {
    competencyDocumentDelete (input: {
      documentId: $documentId,
      workspaceId: $workspaceId
    }) {
        document {
            documentId
            workspaceId
      }
    }
  }
`;